import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  // Hide CTA on assessment and results pages (user already paid)
  const hidePreviewButton = location.pathname.startsWith('/assessment') ||
                            location.pathname.startsWith('/results');

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 focus:outline-none">
            <img
              src="/logo.png"
              alt="AsiliGuide"
              className="w-28 sm:w-36 h-auto"
            />
            <span className="text-sm sm:text-lg font-semibold text-gray-900">
              Compliance Snapshot
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-6">
            <a
              href="https://asiliguide.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gray-600 hover:text-gray-900 transition"
            >
              Main Platform
            </a>
            <a
              href="mailto:support@getasili.com"
              className="text-sm text-gray-600 hover:text-gray-900 transition"
            >
              Support
            </a>
            {!hidePreviewButton && (
              <Link
                to="/preview"
                className="px-4 py-2 rounded-xl text-sm font-medium text-white hover:opacity-90 transition"
                style={{ backgroundColor: '#009688' }}
              >
                Preview Checklist
              </Link>
            )}
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-50 transition"
          >
            {mobileMenuOpen ? (
              <X className="w-6 h-6 text-gray-600" />
            ) : (
              <Menu className="w-6 h-6 text-gray-600" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden border-t border-gray-200 bg-white">
          <div className="px-4 py-3 space-y-3">
            <a
              href="https://asiliguide.com"
              target="_blank"
              rel="noopener noreferrer"
              className="block text-sm text-gray-600 hover:text-gray-900 py-2"
            >
              Main Platform
            </a>
            <a
              href="mailto:support@getasili.com"
              className="block text-sm text-gray-600 hover:text-gray-900 py-2"
            >
              Support
            </a>
            {!hidePreviewButton && (
              <Link
                to="/preview"
                onClick={() => setMobileMenuOpen(false)}
                className="block text-center px-4 py-3 rounded-xl text-sm font-medium text-white hover:opacity-90 transition min-h-[44px] flex items-center justify-center"
                style={{ backgroundColor: '#009688' }}
              >
                Preview Checklist
              </Link>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
